import { adminRolesAPI } from 'api/admin-roles';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { locales } from 'utils/constants';

export function useDeleteAdminRole() {
  const mutation = useMutation({
    mutationFn: adminRolesAPI.delete,
    onSuccess: () => {
      toast(locales.deleteSuccess, { type: 'success' });
    },
  });

  return mutation;
}
